import { SET_HOME, SET_CURRENTSCENE, SET_TRANSITIONING, SET_HOMENAVIN, SET_ANIMRIGHT, SET_INFOCARDIN, SET_LOCALE, SET_BREAKPOINT } from './actionTypes'

export const _setHome = (bool) => ({
    type: SET_HOME,
    payload: bool
})

export const _setCurrentScene = (num) => {
    return ({
        type: SET_CURRENTSCENE,
        payload: num
    })
}

export const _setTransitioning = (bool)=> ({
    type: SET_TRANSITIONING,
    payload: bool
})

export const _setHomeNavIn = (bool)=> ({
    type: SET_HOMENAVIN,
    payload: bool
})

export const _setAnimRight = (bool)=> ({
    type: SET_ANIMRIGHT,
    payload: bool
})

export const _setInfocardIn = (bool)=> ({
    type: SET_INFOCARDIN,
    payload: bool
})

export const _setLocale = (string)=> ({
    type: SET_LOCALE,
    payload: string
})

export const _setBreakpoint = (string)=> ({
    type: SET_BREAKPOINT,
    payload: string
})